import { FC } from "react";
import { SwitchProps } from "./Switch.constants";
import { Input, Label } from "reactstrap";
import { Controller } from "react-hook-form";

const Switch: FC<SwitchProps> = ({
  control,
  name,
  onChangeHandler,
  defaultValue,
  dataOnLabel = "Evet",
  dataOffLabel = "Hayır",
  color = "primary",
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <>
            <Input
              {...field}
              type="checkbox"
              id={name}
              name={name}
              onChange={(e) => {
                onChangeHandler && onChangeHandler(e.target.checked);
              }}
              switch={color}
              defaultChecked={defaultValue === false ? false : true}
            />
            <Label
              htmlFor={name}
              data-on-label={dataOnLabel}
              data-off-label={dataOffLabel}
            ></Label>
          </>
        );
      }}
    />
  );
};

export default Switch;
